import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      position="bottom-right"
      className="toaster group"
      style={{
        '--normal-bg': '#F4F7F6',
        '--normal-border': 'rgba(21, 50, 84, 0.2)',
        '--normal-text': '#153254',
        '--success-bg': '#F4F7F6',
        '--success-border': 'rgba(10, 35, 32, 0.3)',
        '--success-text': '#153254',
      }}
      toastOptions={{
        style: {
          background: '#F4F7F6',
          color: '#153254',
          border: '1px solid rgba(21, 50, 84, 0.2)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        },
        classNames: {
          toast: "group toast",
          title: "text-[#153254] font-medium",
          description: "text-[#153254]/70",
          actionButton: "bg-[#0A2320] text-white",
          cancelButton: "bg-gray-100 text-[#153254]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
